<template>
  <div>
    <v-layout row container justify-center>

      <v-dialog v-model="dialog" persistent max-width="950">
        <v-card light class="pt-2">

          <v-btn icon absolute right @click="closeDialog" style="z-index: 10;">
            <v-icon>close</v-icon>
          </v-btn>

          <span class="partido-title">Chat {{ partidoDescription }}</span>
          <!-- <div style="display: flex; align-self: flex-start; margin-left: 25px; margin-bottom: 15px;">
            <span style="font-size: 1.2em;"><b>{{ partidoTorneo }} {{ partidoFecha }}</b> - {{ partidoDate }}</span>
          </div> -->

          <v-divider></v-divider>

          <v-layout row style="min-height: 435px;">

            <v-flex xs3 style="border-right: 1px solid #e0e0e0; background-color: #fafafa; padding-top: 0px;">
              <div
                v-for="(item, index) in opciones"
                :key="item.texto"
                @click="tabActiva = index"
                class="custom-vertical-tab"
                :class="{'active-tab': tabActiva === index}"
              >
                <v-icon :color="tabActiva === index ? 'primary' : 'grey darken-1'" style="margin-right: 15px;">
                  {{ item.logo }}
                </v-icon>
                <span :class="tabActiva === index ? 'primary--text' : 'grey--text text--darken-2'" style="font-weight: 500; font-size: 15px;">
                  {{ item.texto }}
                </span>
              </div>
            </v-flex>

            <v-flex xs9>
              <div v-show="tabActiva === 0">
                <ChatChat :mensajes="mensajes"></ChatChat>
              </div>

              <div v-show="tabActiva === 1">
                <ChatArchivos :mensajes="mensajes" @irAlMensaje="enfocarMensaje"></ChatArchivos>
              </div>

              <div v-show="tabActiva === 2">
                <ChatChat :is-from-favoritos="true" :mensajes="mensajes" @irAlMensaje="enfocarMensaje"></ChatChat>
              </div>
              <div v-show="tabActiva === 3">
                <ChatChat :is-from-fijado="true" :mensajes="mensajes" @irAlMensaje="enfocarMensaje"></ChatChat>
              </div>
              <div v-show="tabActiva === 4">
                <ChatInfoPartido :partido-id="chatId"></ChatInfoPartido>
              </div>
            </v-flex>

          </v-layout>
        </v-card>
      </v-dialog>

    </v-layout>
  </div>
</template>
<script>

import ChatChat from './ChatChat.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import ChatArchivos from './ChatArchivos.vue'
import ChatInfoPartido from './ChatInfoPartido.vue'

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations: {
    nuevoMensaje: { required }
  },

  components: {
    ChatChat,
    ChatArchivos,
    ChatInfoPartido
  },

  props: {
    partidoDescription: null,
    partidoId: null,
    consultaId: null,
    chatId: null,
    partidoTorneo: null,
    partidoFecha: null,
    partidoDate: null

  },

  data () {
    return {
      loading: true,
      consulta: {},
      previousAuthor: '',
      history: [],
      derivar: false,
      showHistoryDialog: false,
      dialog: false,
      comentarioPrePartido: {},
      files: [],
      items: [],
      file: null,
      nuevoMensaje: '',
      saving: false,
      mensajes: [],
      tabActiva: 0,
      opciones: [
        { texto: 'Chat', logo: 'chat', visible: true },
        { texto: 'Archivos', logo: 'mdi-file', visible: true },
        { texto: 'Favoritos', logo: 'mdi-star', visible: true },
        { texto: 'Fijados', logo: 'mdi-pin', visible: true },
        { texto: 'Info y participantes', logo: 'mdi-information', visible: true }
      ]
    }
  },

  methods: {
    limpiarFormulario () {
      this.nuevoMensaje = ''

      this.$v.$reset()

      this.files = []

      this.assets = []

      if (this.$refs.fileInput) {
        this.$refs.fileInput.cleanContent()
        this.postSubmit()
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = {
          texto: this.nuevoMensaje,
          padre: this.comentarioId
        }
        this.axios
          .post('/informe-auditoria/comentario-pre-partido-respuesta/new', payload)
          .then((response) => {
            let newMessage = response.data
            if (this.assets.length > 0) {
              this.axios
                .put('/informe-auditoria/comentario-pre-partido/upload-s3/' + newMessage.id, { assets: this.assets })
                .then((responseS3) => {
                  this.limpiarFormulario()
                  this.fetchData()
                  this.saving = false
                })
                .catch(error => { this.$store.commit('setErrorMsg', error) })
            } else {
              this.limpiarFormulario()
              this.fetchData()
              this.saving = false
            }
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    enfocarMensaje (mensajeId) {
      this.tabActiva = 0

      this.$nextTick(() => {
        const el = document.getElementById('msg-' + mensajeId)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          el.classList.add('highlight-flash')
          setTimeout(() => {
            el.classList.remove('highlight-flash')
          }, 2000)
        }
      })
    },
    fetchData (url) {
      const endpoint = url || `informe-auditoria/chats/${this.chatId}/mensajes/`

      this.axios
        .get(endpoint)
        .then(response => {
          const nuevosMensajes = response.data.results || response.data

          this.mensajes = [...this.mensajes, ...nuevosMensajes]

          if (response.data.next) {
            this.fetchData(response.data.next)
          }
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    differentAuthor (currentAuthor) {
      return (this.consulta.autor.username !== currentAuthor.username)
    },
    addMessage (newMessage) {
      this.consulta.mensajes.push(newMessage)
      this.consulta.canReply = true
      this.$router.go()
    },
    updateConsulta () {
      this.hideEdit()
      this.$router.go()
    },
    getAttachmentName (attachment) {
      return attachment.split('/').slice(-1).pop()
    },
    showDialog () {
      this.dialog = true
      this.fetchData()
    },
    closeDialog () {
      this.dialog = false
      this.$emit('closeChatPopUp')
    }
  },

  computed: {
    showResponseArea () {
      if (this.consulta.hasOwnProperty('canReply')) {
        return this.consulta.canReply
      }
      return false
    },
    isOpen () {
      return this.consulta.estado !== 'Cerrada'
    },
    isDerivada () {
      return this.consulta.derivadaFrom !== ''
    },
    nuevoMensajeErrors () {
      const errors = []
      if (!this.$v.nuevoMensaje.$dirty) return errors
      !this.$v.nuevoMensaje.required && errors.push('El cuerpo es requerido.')
      return errors
    }
  },

  created () {
  },
  mounted () {
    this.showDialog()
  }
}

</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.4em;
  color: rgb(99, 95, 95);
}

.partido-title {
  color: lightslategray;
  font-size: 1.7em;
  color: rgb(60, 145, 197);
  padding-left: 1em;
  padding-top: 1em
}

a {
  color: #1787c9;
}

.center {
  text-align: center;
}

.btn-volver {
  margin-top: 10px;
}
.custom-vertical-tab {
  display: flex;
  align-items: center;
  padding: 10px 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-right: 3px solid transparent;
}

.custom-vertical-tab:hover {
  background-color: #eeeeee;
}

.active-tab {
  background-color: #e3f2fd;
  border-right: 3px solid #1976D2 !important;
}

.placeholder-container {
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>
